import { AppSettings } from "appSettings/appSettings.dev";
import { Action, Group, MenuItem, User, Business } from "../types";
import { BaseService } from "./BaseService";

class SecurityService {
  private baseService: BaseService;
  constructor() {
    this.baseService = new BaseService(AppSettings.apiURL);
  }

  async GetUserBusinessUnits(email: string): Promise<Business[]> {
    const response = await this.baseService.get<Business[]>(`/Security/GetUserBusinessUnits?email=${email}`);
    return response.data;
  }

  async getUser(userId: string): Promise<User> {
    const response = await this.baseService.get<User>(`/Security/GetUser?userID=${userId}`);
    return response.data;
  }

  async getUsers(): Promise<User[]> {
    const response = await this.baseService.get<User[]>(`/Security/GetAllUsers`);
    return response.data;
  }

  async createUser(user: User): Promise<string> {
    const response = await this.baseService.post<User, string>("/Security/SaveUser", user);
    return response;
  }

  async updateUser(user: User): Promise<any> {
    const response = await this.baseService.post<User, any>("/Security/UpdateUser", user);
    return response.data;
  }

  async changeStatusUser(user: User): Promise<any> {
    const response = await this.baseService.post<User, any>("/Security/ChangeStatusUser", user);
    return response.data;
  }

  async saveGroup(group: Group): Promise<string> {
    const response = await this.baseService.post<Group, string>("/Security/SaveGroup", group);
    return response;
  }

  async updateGroup(group: Group): Promise<any> {
    const response = await this.baseService.post<Group, any>("/Security/UpdateGroup", group);
    return response.data;
  }

  async deleteGroup(groupID: number): Promise<string> {
    const response = await this.baseService.post<string>(`/Security/DeleteGroup?groupID=${groupID}`);
    return response.data;
  }

  async getGroups(): Promise<Group[]> {
    const response = await this.baseService.get<Group[]>(`/Security/GetGroups`);
    return response.data;
  }

  async getMenu(email: string): Promise<MenuItem[]> {
    const response = await this.baseService.get<MenuItem[]>(`/Security/GetMenu?email=${email}`);
    return response.data;
  }

  async getActions(): Promise<Action[]> {
    const response = await this.baseService.get<Action[]>(`/Security/GetActions`);
    return response.data;
  }
  async getGroup(groupID: string): Promise<Group> {
    const response = await this.baseService.get<Group>(`/Security/GetGroup?groupID=${groupID}`);
    return response.data;
  }
}

export const securityService = new SecurityService();
